// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "NotFound" + "." + "26f3d0e6" + ".chunk.css";
};